import Slider from "rc-slider";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import { generalSettingsSchema } from "../../../validations/generalSettingsValidations";
import BreadCrumbs from "../../common/breadcrumbs";
import { useFormik } from "formik";
import {
	useAddOpaCommission,
	useGetOpaCommission,
} from "../../../queryHooks/useSettings";
import { useStore } from "../../../zustand/store";

//  Component starts
const General = () => {
	const setLoading = useStore((state) => state.setLoading);

	const { data: dataGetopaCommission, refetch } = useGetOpaCommission();

	const {
		mutateAsync: updateOpaCommssion,
		error: errorUpdateOpaCommssion,
		data: dataUpdateOpaCommssion,
	} = useAddOpaCommission();

	useEffect(() => {
		if (dataUpdateOpaCommssion) {
			setLoading(false);
			if (dataUpdateOpaCommssion.status === "success") {
				CS.showSuccessMessage(dataUpdateOpaCommssion.message);
				refetch();
			} else if (dataUpdateOpaCommssion.status === "fail") {
				CS.showErrorMessage(dataUpdateOpaCommssion.message);
			}
		}
	}, [dataUpdateOpaCommssion]);

	useEffect(() => {
		if (errorUpdateOpaCommssion) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateOpaCommssion.response?.data?.message);
		}
	}, [errorUpdateOpaCommssion]);

	const { values, errors, handleChange, handleSubmit, touched, setFieldValue } =
		useFormik({
			initialValues: {
				platform_fee_percentage:
					dataGetopaCommission?.data?.[0]?.platform_fee_percentage,
			},
			validationSchema: generalSettingsSchema,
			enableReinitialize: true,
			onSubmit: (value) => {
				updateOpaCommssion({
					platform_fee_percentage: value.platform_fee_percentage.toString(),
				});
				setLoading(true);
			},
		});

	return (
		<>
			<BreadCrumbs title="Settings" data={[{ label: "General Settings" }]} />
			<div className="card">
				<form onSubmit={(e) => handleSubmit(e)}>
					<div id="accordion" className="collapse-setting">
						<div className="card mb-5 bg-transparent">
							<div
								id="collapseOne"
								className="collapse show"
								aria-labelledby="headingOne"
								data-parent="#accordion"
							>
								<div className="row">
									<div className="col-md-6">
										<div className="card-strip h-100">
											<div className="modal-header p-0 pb-3 mb-4 w-100">
												<h5 className="modal-title">Commissions</h5>
											</div>

											<div className="form-group mb-md-5 mb-3">
												<label htmlFor="opaCommission">
													Opa Commission (Order Processing Fee) (%)
												</label>
												<input
													title=""
													type="number"
													className="form-control"
													id="platform_fee_percentage"
													name="platform_fee_percentage"
													value={values.platform_fee_percentage}
													onChange={handleChange}
												/>

												<Slider
													className="mt-3"
													min={0}
													max={100}
													value={values.platform_fee_percentage}
													onChange={(value) =>
														setFieldValue("platform_fee_percentage", value)
													}
												/>
											</div>
											<div className="error-message-password">
												<span className="text-danger d-block mb-2">
													{errors.platform_fee_percentage &&
													touched.platform_fee_percentage
														? errors.platform_fee_percentage
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-12 btn-blocks text-right">
						<button className="btn btn-primary glow-primary mr-4" type="submit">
							Save Changes
						</button>
						<Link to={URL.dashboard} className="btn btn-outline-primary">
							Cancel
						</Link>
					</div>
				</form>
			</div>
		</>
	);
};

export default General;
